import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { FolderOverviewService } from '../store/services'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'folder-overview-retainer-breakdown',
  templateUrl: './folder-overview-retainer-breakdown.component.html',
  styleUrls: ['./folder-overview-retainer-breakdown.component.scss'],
})
export class FolderOverviewRetainerBreakdownComponent {
  get id(): number {
    return this.folderOverviewService.folderId
  }

  constructor(
    private envService: EnvService,
    private titleService: Title,
    private folderOverviewService: FolderOverviewService
  ) {
    this.titleService.setTitle('Folder Overview | Retainer Breakdown')
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/folder-overview/${this.id}/sow-retainer-breakdown?sow_id=${this.id}`
  }
}
